module.exports = __webpack_public_path__ + "static/media/my-education.2ab23cde.svg";